import React from 'react';
import { Modal, Button } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

type Tprops = {
  open: boolean;
  onSave: () => void;
  onNoSave: () => void;
  onCancel: () => void;
};

export const SaveConfirmModal: React.FC<Tprops> = (props: Tprops) => {
  const { open, onSave, onNoSave, onCancel } = props;

  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.container}
    >
      <div className={classes.subpaper}>
        <div style={{ textAlign: 'center' }}>保存しますか？</div>
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <Button
            variant='contained'
            color='primary'
            style={{ backgroundColor: '#52555F' }}
            onClick={onSave}
          >
            はい
          </Button>
          <Button
            variant='contained'
            color='primary'
            style={{ backgroundColor: '#52555F' }}
            onClick={onNoSave}
          >
            いいえ
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '400px',
      height: '150px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around'
    }
  })
);

export default SaveConfirmModal;
